/***
 * Copyright (c) Myia 2023-2025 - All Rights Reserved
 */
import { Component, ReactNode } from 'react';

interface Props {
    children: ReactNode;
    removeStep?: () => void;
}

interface State {
    hasError: boolean;
    error: Error | null;
}

class StepErrorBoundary extends Component<Props, State> {
    public state: State = {
        hasError: false,
        error: null,
    };

    public static getDerivedStateFromError(error: Error): State {
        return { hasError: true, error };
    }

    public render() {
        if (this.state.hasError) {
            return (
                <div className="p-4 border border-red-500 rounded-md bg-red-50 text-red-700">
                    <p>Error detected in step: {this.state.error?.message || 'Unknown error'}</p>
                    {this.props.removeStep && (
                        <button
                            onClick={this.props.removeStep}
                            className="mt-2 px-3 py-1 bg-red-500 text-white rounded hover:bg-red-600"
                        >
                            Remove this step
                        </button>
                    )}
                </div>
            );
        }

        return this.props.children;
    }
}

export default StepErrorBoundary;
